import React from "react";
import { OriginRoute, DestinyRoute, ITripStopItem } from "@types";
import { Button } from "@rio-cloud/rio-uikit";

interface InputItemProps {
  id: string;
  label: string;
  value: string;
  iconLeft: string;
  onCheckpointItem?: () => void;
  disabled?: boolean;
}

const Input: React.FC<InputItemProps> = ({ id, label, value, iconLeft, onCheckpointItem, disabled = false }) => (
  <div className="display-flex align-items-center margin-top-10 margin-bottom-10">
    <div className="width-100pct">
      <label htmlFor={id}>{label}</label>
      <div className="input-group gap-15">
        <span className="input-group-addon">
          <span className={iconLeft} />
        </span>
        <input id={id} className="form-control" type="text" placeholder="" disabled value={value} />
        <Button 
          bsStyle={Button.PRIMARY} 
          iconOnly 
          iconName="rioglyph rioglyph-checkboxes" 
          disabled={disabled} 
          onClick={onCheckpointItem} 
        />
      </div>
    </div>
  </div>
);

const formatStopEta = (value: string): string => {
  const [datePart, timePart] = value.split(" ");
  if (!timePart) return value;

  return `${datePart} às ${timePart}`;
};

const buildStopLabel = (stop: ITripStopItem): string => {
  if (stop.actualArrival) return `${stop.note} - Chegada em ${formatStopEta(stop.actualArrival)}`;
  if (stop.estimatedArrival) return `${stop.note} - Previsão de chegada ${formatStopEta(stop.estimatedArrival)}`;
  if (stop.isUnplanned || !stop.routeStopId) return stop.note;
  return `${stop.note} - Previsão de chegada --`;
};

interface StopsSectionProps {
  origin?: OriginRoute;
  destiny?: DestinyRoute;
  stops?: ITripStopItem[];
  onClickCheckpoint?: (id: string) => void;
}

export const StopsSection: React.FC<StopsSectionProps> = ({ origin, destiny, stops, onClickCheckpoint }) => (
  <div className="padding-y-10 padding-x-15">
    <Input 
      id="trip-stop-origin"
      label="Origem" 
      value={origin?.address?.label || ""} 
      iconLeft="rioglyph rioglyph-start" 
      disabled 
    />
    {stops && stops.length > 0 && (
      <div className="padding-left-20">
        {stops.map((stop, index) => (
          <Input
            key={stop.routeStopId ?? stop.checkpointId ?? `stop-${index}`}
            id={`trip-stop-${index}`}
            label={buildStopLabel(stop)}
            value={stop.label}
            iconLeft="rioglyph rioglyph-pushpin"
            disabled={stop.isUnplanned || !stop.checkpointId}
            onCheckpointItem={() => !stop.isUnplanned && stop.checkpointId && onClickCheckpoint?.(stop.checkpointId)}
          />
        ))}
      </div>
    )}
    <Input 
      id="trip-stop-destiny"
      label="Destino" 
      value={destiny?.address?.label || ""} 
      iconLeft="rioglyph-finish" 
      disabled 
    />
  </div>
);
